import { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { usePagination, useTable } from 'react-table';
import { useAppContext } from '../../appProvider/contextProvider';
import { deleteAgent, getAgents } from '../../services/userManagementService';

import NoDataImage from '../../assets/images/illustration.svg';
import Loader from '../../components/Loader/loader';
import { toast } from 'react-toastify';
import HelperComponent from '../../components/HelperComponent/HelperComponent';



const columns =  [
    {
        Header: 'Name',
        accessor: 'name', // accessor is the "key" in the data
    },
    {
        Header: 'Email',
        accessor: 'email', // accessor is the "key" in the data
    },
    {
        Header: 'Phone Number',
        accessor: 'phone', // accessor is the "key" in the data
    },
    {
        Header: 'Role',
        accessor: 'role',
        Cell: (props) => <span style={{textTransform: 'capitalize'}} >{props.value}</span>, 
    },
    {
        Header: 'Action',
    },
]


const UserManagement = () => {

    const history =  useHistory();

    const {selectedWebsite, isFetching, isMutating} = useAppContext();

    const [agents, setAgents] = useState([]); 

    useQuery(['fetchAgents', selectedWebsite?.id], () => getAgents(selectedWebsite?.id), {
        enabled: !!selectedWebsite,
        onSuccess: (agents) => {
            if(agents.errors) {

            } else {
                setAgents(agents);
            }
        }
    });


    const agentsData = useTable({
        columns,
        data: agents,
        initialState: { pageSize: 20 },
    }, usePagination);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
    } = agentsData;



    const editAgent = (data) => {
        history.push({
            pathname: '/add-agent',
            state: { agentsData: data }
        });
    }

    const deleteUserAgent = useMutation((id) => {
        return deleteAgent(selectedWebsite?.id, id);
    }, {
        onSuccess: (user, agentId) => {
            if(user.errors) {

            }else {
                const remainingAgents = agents.filter(({id}) => id !== agentId);
                setAgents(remainingAgents);
                toast.success('Agent deleted successfully!');
            }
        }
    })

    const delAgent = (event, id) => {
        event.preventDefault();
        deleteUserAgent.mutate(id)
    }

    const getRows = (cell, row) => {
        if(cell?.column?.Header === 'Action') {
            return <div className="d-flex">
                <button 
                    className="btn btn-outline mx-1"
                    onClick={() => editAgent(row.original)}
                >
                    <i className="icon icon-edit"></i>
                </button>
                <button
                    className="btn btn-danger mx-1"
                    onClick={(event) => delAgent(event, row?.original?.id)}
                >
                    <i className="icon icon-delete"></i>
                </button>
            </div>
        }
        return cell.render('Cell');
} 


    return <>
    <div className={ !!(isMutating || isFetching) ? 'loader full-height scrollable_y' : 'full-height scrollable_y'}>
        {!!(isMutating || isFetching) && <Loader />}
        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <h3 className="mb-0">
                        User management
                        <HelperComponent
                            component={'User management'}  
                            href="https://chirpyweb.com/documentation_posts/user-management/" />
                    </h3>
                    <div className="d-flex">
                        <button className="btn btn-primary" onClick = {() => history.push('/add-agent')} ><i className="icon icon-add mr-2"></i>Add User</button>
                    </div>
                </div>                                
            </div>
            <div className="panel-body d-flex flex-column full-height scrollable_y">
                <div className="table-responsive full-height">
                    <table className="table table-hover"  {...getTableProps()}>
                        <thead>
                            {
                                headerGroups.map(headerGroup => (
                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                        {
                                            headerGroup.headers.map(column => (
                                                <th {...column.getHeaderProps()}>
                                                    {column.render('Header')}
                                                </th>
                                            ))
                                        }
                                    </tr>
                                ))
                            }
                            {/* <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone Number</th>
                                <th>Role</th>
                            </tr> */}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {   // Loop over the table rows
                                page.map(row => {
                                    // Prepare the row for display
                                    prepareRow(row)
                                    return (
                                    // Apply the row props
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell =>  <td {...cell.getCellProps()}>{getRows(cell, row)}</td>)}
                                    </tr>
                                    )
                                })
                            }
                            {
                                agents.length <= 0 &&  <tr>
                                <td colSpan="6" align="center">
                                    <div className="d-flex flex-column align-items-center justify-content-center mt-5">
                                        <img src={NoDataImage} className="illustration-image" />
                                        <h5 className="medium text-dark mt-2">No agents added, please add one</h5>
                                        <button className="btn btn-primary my-2" onClick={() => history.push('/add-agent')} >Add Agents  </button>
                                    </div>                                                    
                                </td>
                            </tr>
                            }
                            {/* <tr>
                                <td>
                                    <div className="media media-center">
                                        <div className="media_figure">
                                            <img src="images/user.png" className="avatar-image" alt="photo"/>
                                        </div>
                                        <div className="media_body">
                                            <h6 className="text-light regular mb-0">Kristin Watson</h6>
                                        </div>
                                    </div>
                                </td>
                                <td><a href="" className="text-grey">kristinwatson@gmail.com</a></td>
                                <td>9564653234</td>
                                <td className="d-flex jusify-content-between">
                                    <div className="custom-control custom-radio mr-3">
                                        <input type="radio" id="customRadio6" name="customRadio" className="custom-control-input" />
                                        <label className="custom-control-label dark-text" for="customRadio6">View</label>
                                    </div>
                                    <div className="custom-control custom-radio mr-3">
                                        <input type="radio" id="customRadio4" name="customRadio" className="custom-control-input" />
                                        <label className="custom-control-label dark-text" for="customRadio4">Edit</label>
                                    </div>                                                
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="customRadio10" name="customRadio" className="custom-control-input" />
                                        <label className="custom-control-label dark-text" for="customRadio10">Send</label>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="media media-center">
                                        <div className="media_figure">
                                            <img src="images/user.png" className="avatar-image" alt="photo"/>
                                        </div>
                                        <div className="media_body">
                                            <h6 className="text-light regular mb-0">Kristin Watson</h6>
                                        </div>
                                    </div>
                                </td>
                                <td><a href="" className="text-grey">kristinwatson@gmail.com</a></td>
                                <td>9564653234</td>
                                <td className="d-flex jusify-content-between">
                                    <div className="custom-control custom-radio mr-3">
                                        <input type="radio" id="customRadio6" name="customRadio" className="custom-control-input" />
                                        <label className="custom-control-label dark-text" for="customRadio6">View</label>
                                    </div>
                                    <div className="custom-control custom-radio mr-3">
                                        <input type="radio" id="customRadio4" name="customRadio" className="custom-control-input" />
                                        <label className="custom-control-label dark-text" for="customRadio4">Edit</label>
                                    </div>                                                
                                    <div className="custom-control custom-radio">
                                        <input type="radio" id="customRadio10" name="customRadio" className="custom-control-input" />
                                        <label className="custom-control-label dark-text" for="customRadio10">Send</label>
                                    </div>
                                </td>
                            </tr> */}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <p className="mb-1 mr-2">Total {agents.length} entries</p>
                    <div className="mb-1">
                        <button className="btn mr-2" disabled={!canPreviousPage}  onClick={() => previousPage()} ><i className="icon icon-chevron-left mr-2"></i>Prev</button>
                        <button className="btn " disabled={!canNextPage} onClick={() => nextPage()} >Next <i className="icon icon-chevron-right ml-2"></i></button>
                    </div>
                </div> 
            </div>
        </div>
    </div>
</>
}

export default UserManagement;